import {useMutation, UseMutationResult} from '@tanstack/react-query';
import {CustomAxiosError, useApiCalls} from "../../../../../../../logics/api_config";
import {useAuth} from "../../../../../../../utils/contexts/auth-context";


const useApiDeleteSchedaCosto = (pk: number | undefined): UseMutationResult<void, CustomAxiosError, {
    pk?: number
}, unknown> => {
    const {DELETE} = useApiCalls()
    const {selectedCompany} = useAuth()

    const doDelete = async ({pk}: {
        pk?: number
    }): Promise<void> => {
        try {
            await DELETE(`/api/company/${selectedCompany?.company_token}/tannery_production/schede_costo/schede_costo/${pk}/`);
        } catch (error) {
            throw error;
        }
    }

    return useMutation<void, CustomAxiosError, { pk?: number }>(
        {
            mutationFn: () => doDelete({pk}),

        });
};

export default useApiDeleteSchedaCosto

